import { gql } from '@apollo/client'

export interface SaveDecisionEditPageRequestInput {
  dealId: number
  dealNumber: number
  userId: string
  userEmailId: string
}

export interface SaveDecisionEditPageDetailsVariables {
  input: SaveDecisionEditPageRequestInput
}

export interface SaveDecisionEditPageDetailsResponse {
  saveDecisionEditPageDetails: {
    isSuccess: boolean
    errorMessage: string
    message: string
    __typename: string
  }
}

export const SAVE_DECISION_EDIT_PAGE_DETAILS = gql`
  mutation saveDecisionEditPageDetails($input: SaveDecisionEditPageRequestInput) {
    saveDecisionEditPageDetails(input: $input) {
      isSuccess
      errorMessage
      message
      __typename
    }
  }
`
